import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowOutTopLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowOutTopLeft"><Path d="M6.5 13.5V21.5H21.5V6.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.25 4.25L10.5 10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 10.5V3.5H10.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowOutTopLeft;
